import { create } from "zustand";
import { IGeolocation } from "@/common/services/types";

interface IState {
  location: IGeolocation | null;
  setLocation: (location: IGeolocation | null) => void;
}

export const useGeolocationStore = create<IState>(
  (set) => ({
    location: null,
    setLocation: (location) => set(() => ({ location })),
  }),
);
